export default {
  focusable: true,
};
